import { useEffect } from "react";
import { useFeatureFlag } from "../../../hooks/useFeatureFlag/useFeatureFlag";
import { Flags } from "../../../feature-flags/flags";

export const RebrandTheme = () => {
    const { enabled } = useFeatureFlag(Flags.ENABLE_REBRAND);

    useEffect(() => {
        document.documentElement.classList.toggle("rebrand", enabled);

        return () => {
            document.documentElement.classList.remove("rebrand");
        };
    }, [enabled]);

    return null;
};
